import React, { useState } from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import SearchTabs from "@frameworks/web/components/Search/SearchTabs";
import EdModalSearchBar from "@frameworks/web/components/generic/EdModalSearchBar";
import searchDi from "@frameworks/web/components/Search/di/servicelocator";
import debounce from "@frameworks/web/utils/debounce";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import OptionChainToolBlock from "@frameworks/web/components/Search/OptionsChainTools";
const Search = (props) => {
    const device = DeviceContext();
    const [searchList, setSearchList] = useState();
    const [searchKey, setSearchKey] = useState();
    const [error, setError] = useState();
    const [loader, setLoader] = useState(false);
    const [opt, setOpt] = useState(false);
    const [openOption, setOpenOption] = useState(false);
    const [activeTab, setActiveTab] = useState("All");
    const [selectedOption, setSelectedOptions] = useState();
    const onSearch = (search) => {
        setSearchKey(search);
        // if (!opt) {
        setLoader(true);
        debounce(function () {
            if (search.length > 2) {
                searchDi.search
                    .getGeneralSearch({
                    searchText: search,
                })
                    .then((data) => {
                    setSearchList(data.assetTypeGroup);
                    setError(undefined);
                })
                    .catch((error) => {
                    setError(error.getErrMsg());
                })
                    .finally(() => setLoader(false));
            }
            else {
                setSearchList(undefined);
                setLoader(false);
            }
        }, 3000)();
        // }
    };
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) && props.searchPopup && (React.createElement(EdModalSearchBar, { show: props.searchPopup, modalBodyContent: opt ? (React.createElement(OptionChainToolBlock, { searchKey: searchKey, setSearch: (key) => onSearch(key), setOptions: (val) => {
                setOpt(val);
                setOpenOption(!val);
            }, setSelectedOptions: setSelectedOptions, setSearchPopup: props.setSearchPopup })) : (React.createElement(SearchTabs, { searchData: searchList, loader: loader, error: error, setLoader: setLoader, search: searchKey, setSearch: setSearchKey, openOption: openOption, setOpt: setOpt, activeTab: activeTab, setActiveTab: setActiveTab, selectedOption: selectedOption, serachPopup: props.setSearchPopup, setShowToc: props.setShowToc, setSymbol: props.setSymbol, setShowMFToc: props.setShowMfToc })), showFooter: false, footerContent: "", headContent: React.createElement(React.Fragment, null,
            React.createElement(SearchBar, { openInputBackground: "bg_aqua_white", searchBarBackground: "bg_aqua_white", iconColors: "txt-midnight-blue", parentClassName: "searchbar-search-block", onCallbackFunction: (str) => {
                    onSearch(str);
                }, searchKey: searchKey, onClose: () => {
                    setOpt(false);
                }, onBack: () => props.setSearchPopup(false) }),
            React.createElement("div", { className: "mic-icon" },
                React.createElement("i", { className: "edel-icon-idle-mic-coloured" },
                    React.createElement("span", { className: "path1" }),
                    React.createElement("span", { className: "path2" })))), setShow: props.setSearchPopup }))));
};
export default Search;
